import { render, staticRenderFns } from "./HighlightsMultibarChart.vue?vue&type=template&id=53a7fdac&scoped=true&"
import script from "./HighlightsMultibarChart.vue?vue&type=script&lang=js&"
export * from "./HighlightsMultibarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a7fdac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
